import { useEffect, useState } from "react";
import { ArrowBack } from "@mui/icons-material";
import { Button, Box, Stack, Typography, Skeleton } from "@mui/material";
import { black, gold } from "./HomeView";
import asa from "./images/asa.avif";
import spinningRecord from "./images/spinning-record.gif";

const AsaView = ({ setCurrentView }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <>
      <Box bgcolor={black} padding={2} textAlign="center">
        <Typography variant="h2" fontFamily="Smokum" color={gold}>
          Railroad Records
        </Typography>
        <Button
          startIcon={<ArrowBack />}
          endIcon={<ArrowBack />}
          sx={{
            backgroundColor: `${gold}`,
            color: `${black}`,
            fontFamily: "Goblin One",
            marginTop: "15px",
          }}
          textAlign="center"
          onClick={() => {
            setCurrentView("home");
          }}
        >
          Go Back
        </Button>
      </Box>
      <Box display="flex" justifyContent="center" margin="15px auto">
        <Stack direction="column" alignItems="center" maxWidth="500px">
          <Box
            sx={{
              width: "14vw",
              height: "21vw",
              minWidth: "260px",
              minHeight: "390px",
              position: "relative",
            }}
          >
            <Skeleton
              variant="rounded"
              width="100%"
              height="100%"
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                visibility: imageLoaded ? "hidden" : "visible",
              }}
            />
            <Box
              component="img"
              src={asa}
              alt="Asa, the Owner"
              onLoad={() => setImageLoaded(true)}
              sx={{
                width: "100%",
                display: "block",
                objectFit: "cover",
                borderRadius: "25px",
                boxShadow: `rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px`,
                visibility: imageLoaded ? "visible" : "hidden",
              }}
            />
          </Box>

          <Typography variant="h1" fontFamily="Smokum" marginTop="15px">
            Asa
          </Typography>
        </Stack>
      </Box>
      <Box display="flex" justifyContent="center">
        <Typography
          padding="15px"
          fontFamily="Goblin One"
          lineHeight="30px"
          maxWidth="800px"
          textAlign="left"
        >
          &emsp; As the owner of Railroad Records, Asa offers a place for music
          lovers from every scene. From records to CDs to cassettes. From rock
          to folk to jazz to hip hop. At Railroad Records, there's a little
          something for everyone.
        </Typography>
      </Box>
      <Box display="flex" justifyContent="center">
        <Typography
          padding="15px"
          fontFamily="Goblin One"
          lineHeight="30px"
          maxWidth="800px"
          textAlign="left"
        >
          &emsp; Born and raised in Palmerton, PA, music has always been a big
          part of Asa's life. He's been collecting vinyl records since he was 13
          and has worked at a couple local record businesses. Since then, he
          graduated from Kutztown University with a bachelor's degree in history
          and from Lehigh Carbon Community College with an associate's degree in
          business management. Visiting renowned stores such as Double Decker
          Records and Princeton Record Exchange, Asa's interest in physical
          media has brought him all over the place. Besides collecting, he
          enjoys tinkering with sound systems and restores vintage Victrola
          record players.
        </Typography>
      </Box>
      <Box padding={1} textAlign="center">
        <Button
          startIcon={<ArrowBack />}
          endIcon={<ArrowBack />}
          sx={{
            backgroundColor: `${black}`,
            color: `${gold}`,
            fontFamily: "Goblin One",
          }}
          textAlign="center"
          onClick={() => {
            setCurrentView("home");
          }}
        >
          Go Back
        </Button>
      </Box>

      <img
        src={spinningRecord}
        alt="Spinning Vinyl Record"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: "-1",
          opacity: "3%",
          width: "25%",
          minWidth: "450px",
        }}
      />
    </>
  );
};

export default AsaView;
